module.exports = __webpack_public_path__ + "static/media/Input_Manufacturer_Needs_-_GBR_care_04-03-2024-removebg-preview.086d1e8c.png";